/* eslint-disable sonarjs/no-duplicate-string */
// src/plugins/featureTogglesPlugin.js
const featureTogglesPlugin = (store) => {
  store.subscribe((mutation, vuexState) => {
    switch (mutation.type) {
      case 'setPresenterLang':
        store.dispatch('featureToggles/updateFeatureContext', {
          presenterLanguage: vuexState.presenterLocale,
        })
        break

      case 'setPlan':
        store.dispatch('featureToggles/updateFeatureContext', {
          plan: vuexState.plan && vuexState.plan.type,
        })
        break
      case 'setCurrentUser':
        store.dispatch('featureToggles/updateFeatureContext', {
          userId: vuexState.currentUser && vuexState.currentUser.id,
          email: vuexState.currentUser && vuexState.currentUser.email,
        })
        break

      default:
        break
    }
  })
}

export default featureTogglesPlugin
